/* PAWSNOVA compact cart benefits, 2026-10-09.
 * The server-rendered section is the source of truth for quantities and savings.
 * No discount writes, no separate BOGO counter, no speculative currency conversion.
 */
(() => {
  if (window.pawsCompactCartBenefits) return;
  window.pawsnovaCartDrawerB = true;
  const selector = '[data-pn-cart-goal]';
  const viewSelector = '[data-paws-cart-benefits-view]';
  let lastView = null;
  let revision = 0;
  let timer = null;
  let controller = null;
  let retries = 0;

  function targets() { return Array.from(document.querySelectorAll(selector)); }
  function loadStyles(doc) {
    const source = doc.querySelector('link[data-paws-cart-benefits-css]');
    if (source && !document.querySelector('link[data-paws-cart-benefits-css]')) {
      document.head.appendChild(source.cloneNode(true));
    }
  }
  function replaceTarget(target, fresh) {
    if (!target.isConnected) return;
    const wasOpen = !!target.querySelector('details[open]');
    const restoreFocus = target.contains(document.activeElement);
    const next = fresh.cloneNode(true);
    next.removeAttribute('aria-busy');
    if (wasOpen && next.querySelector('details')) next.querySelector('details').open = true;
    target.replaceWith(next);
    if (restoreFocus) next.querySelector('summary')?.focus({ preventScroll: true });
  }
  function keepEstimatesConservative() {
    // While cart state changes, don't leave a potentially incompatible 10% price visible.
    document.querySelectorAll('[data-paws-addon-price][data-estimated="true"]').forEach((node) => {
      const regular = node.dataset.regularPrice;
      if (!regular) return;
      const strong = document.createElement('strong');
      strong.textContent = regular;
      node.replaceChildren(strong);
      node.dataset.estimated = 'false';
    });
  }
  function markBusy(busy) {
    targets().forEach((node) => {
      if (busy) node.setAttribute('aria-busy', 'true');
      else node.removeAttribute('aria-busy');
    });
  }
  function endpoint() {
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = window.routes?.cart_url || `${root}cart`;
    const url = new URL(cartUrl, window.location.origin);
    const current = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    url.searchParams.set('section_id', 'paws-cart-benefits');
    return url;
  }
  async function refresh(expectedRevision) {
    if (!targets().length) return;
    controller?.abort();
    const request = new AbortController();
    controller = request;
    try {
      const response = await fetch(endpoint().toString(), {
        credentials: 'same-origin', cache: 'no-store', signal: request.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('Cart benefits could not be refreshed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const view = doc.querySelector(viewSelector);
      if (!view) throw new Error('Cart benefits section missing');
      if (expectedRevision !== revision || controller !== request) return;
      loadStyles(doc);
      lastView = view.cloneNode(true);
      targets().forEach((node) => replaceTarget(node, view));
      retries = 0;
    } catch (error) {
      if (error.name === 'AbortError' || expectedRevision !== revision) return;
      // A failed refresh must not remove a previously visible shipping progress bar.
      targets().forEach((node) => {
        if (!node.matches(viewSelector) && lastView) replaceTarget(node, lastView);
        else node.removeAttribute('aria-busy');
      });
      if (retries < 2) {
        retries += 1;
        timer = setTimeout(() => refresh(expectedRevision), 400 * retries);
      }
    }
  }
  function schedule(event) {
    const source = event?.source || event?.detail?.source;
    if (source !== 'paws-benefits-render') keepEstimatesConservative();
    revision += 1;
    retries = 0;
    controller?.abort();
    clearTimeout(timer);
    markBusy(true);
    const nextRevision = revision;
    timer = setTimeout(() => refresh(nextRevision), 90);
  }
  function init() {
    const initialView = document.querySelector(viewSelector);
    if (initialView) lastView = initialView.cloneNode(true);
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('paws:cart-data', schedule);
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', (event) => { if (event.persisted) schedule(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    const observer = new MutationObserver((mutations) => {
      let needsRefresh = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const oldGoals = [];
          if (node.matches(`${selector}:not(${viewSelector})`)) oldGoals.push(node);
          oldGoals.push(...node.querySelectorAll(`${selector}:not(${viewSelector})`));
          oldGoals.forEach((goal) => {
            if (lastView) replaceTarget(goal, lastView);
            needsRefresh = true;
          });
        });
      });
      if (needsRefresh) schedule({ source: 'paws-benefits-render' });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    if (lastView) targets().filter((node) => !node.matches(viewSelector)).forEach((node) => replaceTarget(node, lastView));
    schedule({ source: 'paws-benefits-render' });
  }
  window.pawsCompactCartBenefits = { refresh: schedule, version: '20261009-compact-v1' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
